import forEach from 'dcode/functions/forEach'
import getPostLink from '@/functions/getPostLink'
import Translation from 'dcode/classes/Translation'

export default function getNavigation (basic) {
  const data = [...basic?.main]

  if (
    basic?.other &&
    basic?.other.length > 0
  ) {
    data.push({ space: true })
    data.push({ subtitle: Translation.get('Other topics') })
    data.push(...basic.other)
  }

  return forEach(
    data,
    item => {
      if (
        'value' in item &&
        item.list?.length > 0
      ) {
        const data = {
          icon: item.icon,
          text: item.text,
          value: item.value
        }

        if (item.list?.length > 1) {
          data.list = forEach(item.list, item => {
            return {
              href: getPostLink(item, true),
              to: getPostLink(item),
              icon: 'none',
              text: item.text,
              value: item.value
            }
          })
        } else {
          data.href = getPostLink(item.list?.[0], true)
          data.to = getPostLink(item.list?.[0])
          data.value = item.list[0].value
        }

        return data
      } else {
        return item
      }
    }
  )
}
